<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">Drugs</h3>
        </v-flex>
        <v-flex xs12 md11 sm12>
          <v-card>
            <v-card-title>
              <v-text-field label="Search" v-model="filterBy" prepend-icon="search" dense clearable></v-text-field>
              <v-spacer></v-spacer>
              <v-menu :close-delay="500" offset-y offset-x>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" small title="Add New">
                    <v-icon left>mdi-pill</v-icon>Add New
                  </v-btn>
                </template>
                <v-list dense shaped>
                  <v-list-item @click="goTo('/drugs/create')">
                    <v-list-item-content>
                      <v-list-item-title>Use a form</v-list-item-title>
                      <v-list-item-subtitle>Add drugs one by one</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="upload = !upload">
                    <v-list-item-content>
                      <v-list-item-title>Upload a spreadsheet</v-list-item-title>
                      <v-list-item-subtitle>Upload in batch</v-list-item-subtitle>
                      <v-list-item-subtitle>Use this method to batch create OR update prices and category</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-title>
            <v-card-text>
              <drugs-table :drugs.sync="drugs.data" :filterBy="filterBy" :loading="loading" :page="page" :items-per-page="perPage"></drugs-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-select label="Items per Page" v-model.number="perPage" :items="paginationList"></v-select>
              <v-pagination v-model="page" :length="pageCount" :total-visible="7" circle></v-pagination>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <modal-dialog :open="upload" @close="upload = false">
        <template #title>Upload List of Drugs</template>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <a href="/documents/drugs.csv" download>Sample File</a>
          </v-card-title>
          <v-card-text>
            <uploadDrugs></uploadDrugs>
          </v-card-text>
        </v-card>
      </modal-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const DrugsTable =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "drugs" */ '@/Components/Drugs/index')
  const UploadDrugs =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "drugs" */ '@/Components/Drugs/upload')
  const ModalDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/dialog')

  export default {
    name: 'DrugsIndex',
    layout,
    metaInfo () {
      return {
        title: 'Drugs Cabinet',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    props: [
      'drugs',
      'search'
    ],
    components: {
      DrugsTable,
      UploadDrugs,
      ModalDialog,
    },
    data () {
      return {
        filterBy: this.search,
        upload: false,
        loading: false,
        toPage: '',
        itemsPerPage: this.drugs.per_page
      }
    },
    methods: {
      loadData: _.debounce(function () {
        this.$inertia.get('/drugs', {
          search: this.filterBy,
          page: this.toPage || 1,
          per_page: this.itemsPerPage,
        }, {
          preserveState: true,
          preserveScroll: true,
          onBefore: () => this.loading = true,
          onFinish: () => this.loading = false,
          only: ['drugs']
        })
      }, 2500)
    },
    watch: {
      'filterBy': function (value, old) {
        if (old != value) {
          this.toPage = 1
        }
        this.loadData()
      },
      'itemsPerPage': 'loadData'
    },
    computed: {
      links () {
        return this.drugs.links
      },
      page: {
        get () {
          return this.drugs.current_page
        },
        set (value) {
          // console.log('Page ', value);
          this.toPage = value
          this.loadData()
        }
      },
      pageCount: {
        get () {
          return this.drugs.last_page
        },
        set (value) {
          // console.log('PageCount', value);
        }
      },
      perPage: {
        get () {
          return parseInt(this.itemsPerPage)
        },
        set (value) {
          this.itemsPerPage = parseInt(value)
        }
      }
    }
  }
</script>
